export const headerData = {
  tableName: 'Company Bots',
  hasSearch: true,
  hasPaging: true,
  fields: [
    {
      fieldName: 'botName',
      headerName: 'Bot Name',
      hasSort: true,
    },
    {
      fieldName: 'version',
      headerName: 'User Type',
    },
    {
      fieldName: 'createdOn',
      headerName: 'Date Created',
      isDatetime: true,
      hasSort: true,
      isDesc: true,
    },
    {
      fieldName: 'createdByUser',
      headerName: 'Created By',
      hasSort: true,
    },
    {
      fieldName: 'isActive',
      headerName: 'Status',
      isSwitch: true,
      hasSort: true,
    },
  ],
};
